export function Richtext(props)
{
    return <div className={props.className} style={props.style} dangerouslySetInnerHTML={{ __html: props.text }} />
}

export default Richtext;
